import Vue from 'vue'
import Router from 'vue-router'
import RatingBeer from './views/RatingBeer.vue'
import RatingFood from './views/RatingFood.vue'
import RatingService from './views/RatingService.vue'
import Mail from './views/Mail.vue'
import ThankYou from './views/ThankYou.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'ratingBeer',
            component: RatingBeer
        },
        {
            path: '/food',
            name: 'ratingFood',
            component: RatingFood
        },
        {
            path: '/service',
            name: 'ratingService',
            component: RatingService
        },
        {
            path: '/mail',
            name: 'mail',
            component: Mail
        },
        {
            path: '/thankyou',
            name: 'thankyou',
            component: ThankYou
        },
    ]
})
